/* eslint-disable import/prefer-default-export */
// @flow
import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import type { RoutineType } from 'types/routines'

export async function listRoutines(
  customerId: string,
  requestParams: any
): Promise<RoutineType[]> {
  return makeGetRequest(`${ApiBase}/routines/${customerId}/`, requestParams)
}
